import { useState } from "react";

import { BoardModel } from "~utils";

import { useViewBoard } from "./use-view-board";

// The board carries no timestamp of its own, so "modified" is inferred by diffing
// successive renders. The first board seen is dated to the epoch rather than now: it is
// the board as loaded, not an edit the user just made, and dating it now would hold
// back every prompt that waits for a lull for the first 30 seconds of the session.
export function useBoardLastModified(): Date | undefined {
  const { board } = useViewBoard();
  const [previousBoard, setPreviousBoard] = useState<BoardModel>();
  const [lastModified, setLastModified] = useState<Date>();

  if (
    board !== undefined &&
    JSON.stringify(board) !== JSON.stringify(previousBoard)
  ) {
    const isFirstBoard = previousBoard === undefined;
    setPreviousBoard(board);
    setLastModified(isFirstBoard ? new Date(0) : new Date());
  }

  if (board === undefined) return undefined;

  return lastModified;
}

export function isRecentlyModified(boardLastModified: Date): boolean {
  const targetDate = new Date(boardLastModified.getTime() + thirtySecondsMs);
  return new Date() < targetDate;
}

const thirtySecondsMs = 1000 * 30;
